import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import AnimatedLottie from "../lottie";

interface LayoutPageProps {
    list: { description: string }[],
    listRoles: { description: string }[],
}
const Solution: React.FC<LayoutPageProps> = ({ list, listRoles }) => {
    return (
        <div className="aimed-solution">
            <FullWrapper isMargin={false} caseName="aimed-solutionCase">
                <div className="aimed-solutionWrapper">
                    <div className="aimed-solutionTitle">Решение</div>
                    <div className="aimed-solutionInner">
                        <div className="aimed-solutionLeft">
                            <div className="aimed-solutionDescription">
                                Нашей команде нужно было с&nbsp;нуля продумать и&nbsp;разработать
                                технологическое программное решение для проведения двух конкурсов
                                с&nbsp;разными механиками.
                            </div>
                        </div>
                    </div>
                    <div className="aimed-solutionInner">
                        <div className="aimed-solutionLeft">
                            <div className="aimed-solutionPirpleBlock">
                                <div className="aimed-solutionPirpleParagraf">
                                    На&nbsp;первом этапе сконцентрировались на&nbsp;аналитической
                                    работе над таким масштабным&nbsp;проектом.
                                </div>
                            </div>
                            <div className="aimed-solutionList">
                                {list &&
                                    list.map(item => (
                                        <div
                                            key={item.description}
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                            className="aimed-solutionParagraf"
                                        ></div>
                                    ))}
                            </div>
                        </div>
                        <div className="aimed-solutionRight">
                            Общие требования к&nbsp;платформе&nbsp;&mdash; высокая
                            отказоустойчивость и&nbsp;принцип&nbsp;открытого кода
                            для&nbsp;обеспечения прозрачности испытаний.
                        </div>
                    </div>
                    <div className="aimed-solutionRelationship">
                        <div className="aimed-solutionSubtitle">
                            Взаимодействие ролей на&nbsp;проекте
                        </div>
                        <div className="aimed-solutionLottie">
                            <AnimatedLottie />
                        </div>
                        <div className="aimed-solutionPirpleBlock">
                            <div className="aimed-solutionPirpleParagraf">
                                На&nbsp;втором этапе, за&nbsp;4&nbsp;месяца, разработали основные
                                модули и&nbsp;элементы платформы, загрузили все медицинские
                                информационные базы, которые нужны для проведения конкурсов.
                            </div>
                        </div>
                        <div className="aimed-solutionList">
                            {listRoles &&
                                listRoles.map(item => (
                                    <div
                                        key={item.description}
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                        className="aimed-solutionParagraf"
                                    ></div>
                                ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Solution;
